/**
 * No-Ambush City entry for the Legendary Arena game engine (WP-757 / D-24587).
 *
 * enterCityIgnoringAmbush places a Villain into City space 0 WITHOUT the villain-deck
 * reveal pipeline: no Ambush, no onCardRevealed rule hooks. It is the Haunt exorcise
 * release path ("the Haunting Villain enters the city, ignoring any Ambush effects").
 *
 * Lives under villainDeck/ (not board/) because it reuses resolveVillainEscape from the
 * reveal module; placing it in board/ would create a board → villain/rules import cycle.
 *
 * No boardgame.io import. No .reduce(). Never throws.
 */
import { pushVillainIntoCity } from '../board/city.logic.js';
import { formatCardRef } from '../log/logDisplay.js';
import { pushLog } from '../log/logPush.js';
import { resolveVillainEscape } from './villainDeck.reveal.js';
/**
 * Pushes `cardId` into City space 0, ignoring its Ambush, and resolves any Villain
 * pushed out of the City exactly as a villain-deck reveal would.
 *
 * // why: WP-757 / D-24587 — an exorcise is NOT a reveal, so onAmbush and the
 * onCardRevealed rule hooks never fire here. An escape it causes is still a normal
 * escape, so it keeps full reveal parity by calling resolveVillainEscape (the rulebook
 * escape procedure — the owed HQ KO + Bystander discard, opened after the move, then
 * card-text Escape effects — plus bystander carry-away, captured heroes to the Escape
 * Pile, the escape→Scheme-Twist branch and the escaped-pile resource-loss check;
 * D-24656). The Secret Invasion Skrull push now runs the same procedure (D-24656).
 *
 * @param G - The game state to mutate (`G.city`, plus escape consequences).
 * @param context - Narrow reveal context (random + ctx.currentPlayer) for the escape.
 * @param implementationMap - Handler map for the escape→Scheme-Twist branch.
 * @param cardId - The Villain instance entering the City.
 */
export function enterCityIgnoringAmbush(G, context, implementationMap, cardId) {
    const pushResult = pushVillainIntoCity(G.city, cardId);
    G.city = pushResult.city;
    pushLog(G, `${formatCardRef(G.cardDisplayData, cardId)} entered the city (exorcised; Ambush ignored).`, 'threat');
    if (pushResult.escapedCard !== null) {
        resolveVillainEscape(G, context, implementationMap, pushResult.escapedCard);
    }
}
//# sourceMappingURL=villainDeck.enterCity.js.map